import { Col, Row } from "antd";
import CustomCard from "components/CustomCard";
import PageHeader from "components/PageHeader";
import { useGetCountPotentialCustomer } from "hooks/potentialCustomer/query";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { buildQueryString, getQuery } from "utils/helperFuncs";
import AllCustomerTab from "./PotentialCustomerList/AllCustomerTab/allCustomerTab";
import CustomerCompletedTab from "./PotentialCustomerList/CustomerCompletedTab/customerCompletedTab";
import CustomerNewTab from "./PotentialCustomerList/CustomerNewTab/customerNewTab";
import StopCaringTab from "./PotentialCustomerList/StopCaringTab/stopCaringTab";
import TakingCareTab from "./PotentialCustomerList/TakingCareTab/takingCareTab";
import { POTENTIAL_TABS } from "./constants";

function PotentialCustomerTabs() {
  const GET_QUERY = getQuery();
  const [activeKeyMain, setActiveKeyMain] = useState(GET_QUERY?.statuses || POTENTIAL_TABS.ALL);

  const { allCount, newCount, takingCareCount, stopCount, completeCaringCount } = useGetCountPotentialCustomer();

  const [reloadKey, setReloadKey] = useState(0);

  const handleChangeTab = (activeKey) => {
    setActiveKeyMain(activeKey);
    buildQueryString({
      params: { statuses: activeKey },
    });
  };

  // Nhấn lại chính tab đang mở cũng phải xoá filter về mặc định như khi nhấn tab bên cạnh — nếu
  // không thì filter chỉ nằm trên URL (vd `customerIDs` khi điều hướng từ màn Đơn hàng sang) không
  // có cách nào gỡ. Phải đổi `reloadKey` để remount vì tab chỉ đọc URL đúng một lần lúc mount.
  const handleTabClick = (activeKey) => {
    if (activeKey !== activeKeyMain) return;
    handleChangeTab(activeKey);
    setReloadKey((prev) => prev + 1);
  };

  const tabList = [
    {
      key: POTENTIAL_TABS.ALL,
      tab: t("potentialCustomer.tabs.all", { count: allCount || 0 }),
    },
    {
      key: POTENTIAL_TABS.NEW,
      tab: t("potentialCustomer.tabs.new", { count: newCount || 0 }),
    },
    {
      key: POTENTIAL_TABS.TAKING_CARE,
      tab: t("potentialCustomer.tabs.takingCare", { count: takingCareCount || 0 }),
    },
    {
      key: POTENTIAL_TABS.STOP_CARING,
      tab: t("potentialCustomer.tabs.stopTaking", { count: stopCount || 0 }),
    },
    {
      key: POTENTIAL_TABS.COMPLETED,
      tab: t("potentialCustomer.tabs.completed", { count: completeCaringCount || 0 }),
    },
  ];
  const contentList = {
    [POTENTIAL_TABS.ALL]: <AllCustomerTab key={reloadKey} />,
    [POTENTIAL_TABS.NEW]: <CustomerNewTab key={reloadKey} />,
    [POTENTIAL_TABS.TAKING_CARE]: <TakingCareTab key={reloadKey} />,
    [POTENTIAL_TABS.STOP_CARING]: <StopCaringTab key={reloadKey} />,
    [POTENTIAL_TABS.COMPLETED]: <CustomerCompletedTab key={reloadKey} />,
  };

  useEffect(() => {
    buildQueryString({
      params: {
        statuses: GET_QUERY.statuses || POTENTIAL_TABS.ALL,
        ...GET_QUERY,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [GET_QUERY.statuses]);

  return (
    <Row>
      <Col span={24}>
        <PageHeader
          pageTitle={t("potentialCustomer.customerList")}
          routes={[
            {
              path: "/setting",
              name: t("seller.systemSetting"),
            },
            {
              path: "#",
              name: t("potentialCustomer.customerManagement"),
            },
          ]}
        />
      </Col>
      <Col span={24}>
        <CustomCard
          tabList={tabList}
          onTabChange={handleChangeTab}
          onTabClick={handleTabClick}
          defaultActiveTabKey={activeKeyMain}
          contentList={contentList}
          activeTabKey={activeKeyMain}
        />
      </Col>
    </Row>
  );
}

export default PotentialCustomerTabs;
